import { useAuth } from '../../context/AuthContext';
import { Badge } from '../ui/badge';
import { Coins } from 'lucide-react';

export const Header = ({ title, subtitle }) => {
  const { user } = useAuth();

  return (
    <header className="glass-header sticky top-0 z-30 px-6 py-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold font-secondary uppercase tracking-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>
          )}
        </div>
        
        {user && (
          <div className="flex items-center gap-4">
            {/* Points balance */}
            <div 
              className="flex items-center gap-2 px-4 py-2 bg-accent/10 rounded-sm border border-accent/20"
              data-testid="header-points-balance"
            >
              <Coins className="w-5 h-5 text-accent" strokeWidth={1.5} />
              <span className="font-semibold text-accent">{user.points_balance?.toLocaleString()}</span>
              <span className="text-sm text-muted-foreground">pts</span>
            </div>
            
            {/* Role badge */}
            <Badge 
              className={`role-badge role-${user.role_id} uppercase text-xs tracking-wider`}
              data-testid="header-role-badge"
            >
              {user.role_id?.replace('_', ' ')}
            </Badge>
          </div>
        )}
      </div>
      <div className="accent-line mt-4" />
    </header>
  );
};
